/**
 * Formats an ISO or string date into an input-friendly date string (YYYY-MM-DD)
 * Suitable for HTML `<input type="date" />`
 */
export const formatDateForInput = (dateString?: string | null): string => {
  if (!dateString) return "";
  return dateString.substring(0, 10);
};

/**
 * Formats a date string into a clean, human-readable display string (e.g., "Jan 08, 2026")
 */
export const formatDateForDisplay = (
  dateString?: string | null,
  fallback: string = "N/A",
): string => {
  if (!dateString) return fallback;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return fallback;

  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
